import dialogController from './dialog.controller';

angular
  .module( 'VSPApp' )
  .controller( 'dialogController', dialogController);